module.exports = __webpack_public_path__ + "e20139074f5046f3947819091c499b0a.svg";